// extracted by mini-css-extract-plugin
export default {"appBody":"global_appBody__l3lxl","cursor":"global_cursor__hj67P","darkCursor":"global_darkCursor__iyMyn","expand":"global_expand__qksSD","cursorAnim3":"global_cursorAnim3__LQitk"};